import { VermogensRekening } from "../../../../.generated/rapportage/rapportagetypes";
import { Column } from "../../components/BaseTable";
import {
  formatDate,
  formatDuration,
  formatPercentage,
  formatCurrency,
} from "../../../formatters";
import { isEmpty } from "../../../utils";

export const getVermogenColumns = (
  soortProduct?: string,
  isHuidig?: boolean
): Column<VermogensRekening>[] => [
  {
    header: soortProduct ?? "",
    accessor: () => "",
  },
  {
    header: "Lopende of nieuw product",
    accessor: isHuidig ? () => "Bestaande polis" : "polis",
  },
  {
    header: "Instelling",
    accessor: "instelling",
  },
  {
    header: "Productnaam",
    accessor: "productnaam",
  },
  {
    header: "Rekeningnummer",
    accessor: "rekeningnummer",
  },
  {
    header: "Contractanten",
    accessor: "contractanten",
  },
  {
    header: "Ingangsdatum",
    accessor: "ingangsdatum",
    dataType: "date",
  },
  {
    header: "Einddatum, looptijd",
    accessor: (row: VermogensRekening) => {
      if (!row.einddatum) return null;

      const formattedDate = formatDate(row.einddatum);
      const durationString = formatDuration(row.looptijdInMaanden);

      return `${formattedDate}${durationString ? ", " + durationString : ""}`;
    },
  },
  {
    header: "Kapitaalopbouw op basis van",
    accessor: "kapitaalopbouwObv",
  },
  {
    header: "Rekening valt fiscaal in",
    accessor: "box",
  },
  {
    header: "Aankoopkosten, verkoopkosten, beheerkosten",
    accessor: (row: VermogensRekening) => {
      if (
        !row.aankoopkostenPercentage ||
        !row.verkoopkostenPercentage ||
        !row.beheerskostenPercentage
      )
        return null;

      return `${formatPercentage(
        row.aankoopkostenPercentage
      )}, ${formatPercentage(row.verkoopkostenPercentage)}, ${formatPercentage(
        row.beheerskostenPercentage
      )}`;
    },
  },
  {
    header: "Doelrendement",
    accessor: "doelrendement",
    dataType: "percentage",
  },
  {
    header: "Voorbeeldrendement",
    accessor: "voorbeeldrendement",
    dataType: "percentage",
  },
  {
    header: "Aanvangsstorting",
    accessor: "aanvangsstorting",
    dataType: "currency",
  },
  {
    header: "Storting, stortingstermijn",
    accessor: (row: VermogensRekening) => {
      if (isEmpty(row.storting) && isEmpty(row.stortingstermijn)) return null;

      return `${formatCurrency(row.storting)}, ${row.stortingstermijn}`;
    },
  },
  {
    header: "Rekening is verpand aan geldverstrekker",
    accessor: "verpand",
  },
  {
    header: "Opbouw kapitaal is bedoeld voor aflossing van hypotheek",
    accessor: "aflossing",
  },
  {
    header: "Lijfrenteclausule",
    accessor: "lijfrenteclausule",
  },
  {
    header: "Actuele waarde, datum waardeoverzicht",
    accessor: (row: VermogensRekening) => {
      if (!row.actueleWaarde || !row.actueleWaardeDatumOverzicht) return null;

      return `${formatCurrency(row.actueleWaarde)}, ${formatDate(
        row.actueleWaardeDatumOverzicht
      )}`;
    },
  },
];
